module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Vuisternens-devant-Romont_neu-8ce7a98a308987fa6c20e75a74a9b4d3.png";